import {
  FormControl,
  FormErrorMessage,
  Input,
  ModalBody,
  ModalFooter,
  Stack,
  StackDirection,
  Text,
  useBreakpointValue,
  VStack,
  FormLabel,
  Button,
} from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";

import SubmitButton from "components/SubmitButton";
import { mobileStyleBreakpoint } from "util/styleHelpers";
import { modalPadding } from "./EmailVerificationForm";
import {
  ExistingUserType,
  InviteNewUserInputProps,
} from "./InviteNewUserModal";
import PermissionsCheckboxSection from "./PermissionsCheckboxSection";

const modalBodyContentPadding = mobileStyleBreakpoint<string | number>(
  "24px",
  0
);
const nameInputsOrientation = mobileStyleBreakpoint<StackDirection>(
  "column",
  "row"
);

// Consider change to use TextInputWrapper, requires potential refactoring of InputWrapper as the underlying useInput hook applies style props
const UserPermissionFormInput = ({
  label,
  id,
  isDisabled,
}: {
  label: string;
  id: keyof InviteNewUserInputProps;
  isDisabled: boolean;
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<InviteNewUserInputProps>();
  return (
    <FormControl isInvalid={!!errors[id]?.message}>
      <FormLabel>{label}</FormLabel>
      <Input isDisabled={isDisabled} {...register(id)} />
      <FormErrorMessage>{errors[id]?.message}</FormErrorMessage>
    </FormControl>
  );
};

const UserPermissionForm = ({
  userId,
  onClose,
}: {
  userId: ExistingUserType;
  onClose: () => void;
}) => {
  const {
    formState: { isValid, isSubmitting },
  } = useFormContext<InviteNewUserInputProps>();

  const nameInputDirection = useBreakpointValue(nameInputsOrientation);

  return (
    <>
      <ModalBody p={modalPadding} h="100%">
        <VStack p={modalBodyContentPadding} spacing={4} align="flex-start">
          <Stack spacing={4} direction={nameInputDirection} w="100%">
            <UserPermissionFormInput
              label="First Name"
              isDisabled={!!userId}
              id="firstName"
            />
            <UserPermissionFormInput
              label="Last Name"
              isDisabled={!!userId}
              id="lastName"
            />
          </Stack>
          <UserPermissionFormInput
            label="Display Name"
            isDisabled={!!userId}
            id="displayName"
          />
          <UserPermissionFormInput
            label="Phone # (optional)"
            isDisabled={!!userId}
            id="phoneNumber"
          />
          <UserPermissionFormInput label="Email" isDisabled={true} id="email" />
          <Text textStyle="label2">
            User Permission Level (select one or more)
          </Text>
          <PermissionsCheckboxSection />
        </VStack>
      </ModalBody>
      <ModalFooter pb={8}>
        <Button variant="outline" mr={3} onClick={onClose}>
          Cancel
        </Button>
        <SubmitButton isDisabled={!isValid} isLoading={isSubmitting}>
          Send Invite
        </SubmitButton>
      </ModalFooter>
    </>
  );
};

export default UserPermissionForm;
